export default __webpack_public_path__ + "language-en-au.json";